import React from "react";
import axios from "axios";
import { Badge } from "react-bootstrap";
import Ratings from "./Ratings";

const Comments = ({review}) => {
  

  const daysAgo = (date) => { 
    const newDate = new Date(date);
    const today = new Date();
    const diffTime = Math.abs(today - newDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };



  return (
    <div className="  px-3 mt-5">
      <div className="d-flex">
        <div
          style={{ flex: "0.2" }}
          className="d-flex align-items-center justify-content-center"
        >
          {
            review.user.profilePic ? (
              <img
                src={review.user.profilePic}
                alt="profile"
                className="rounded-circle"
                style={{ width: "70px", height: "70px" }}
              />
            ) : (
              <i class="bi bi-person-circle " style={{ fontSize: "70px" }}></i>
            )
          }
        </div>
        <div
          style={{ flex: "0.8", background: "#fff", borderRadius: "10px" }}
          className="py-3 px-3"
        >
          <h4
            style={{
              fontSize: "1.154rem",
              fontWeight: "600",
              color: "#566985",
            }}
            className="py-3"
          >
            {" "}
           {review.user.userName}
          </h4>
          <p style={{ color: "#566985" }} className="py-2">
            {review.review}
          </p>
          <br />

          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex">
              <i class="bi bi-calendar-date text-warning px-2"></i>
              <p> {daysAgo(review.createdAt)===1? 'Today': `${daysAgo(review.createdAt)  } days ago `}</p>
            </div>
            <div>

            <Ratings rating={review.rating}/>
            </div>
            <div className="d-flex align-items-center justify-content-center" >
              <Badge bg="success">Reply </Badge>
              {/* <p className="text-center mt-1 mx-1">
                Your comment is awaiting moderation.
              </p> */}
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Comments;
